export const optimizationGoalOptions = [
  { id: 0, value: '', label: 'Default' },
  { id: 1, value: 'OFFSITE_CONVERSIONS', label: 'Conversions' },
  { id: 2, value: 'VALUE', label: 'Value' },
];

export const objectiveOptions = [
  { id: 1, value: 'OUTCOME_SALES', label: 'Sales', optimizationGoalOptions: [0, 1, 2] },
  { id: 2, value: 'OUTCOME_TRAFFIC', label: 'Traffic', optimizationGoalOptions: [0] },
  { id: 3, value: 'OUTCOME_LEADS', label: 'Leads', optimizationGoalOptions: [0] },
  { id: 4, value: 'OUTCOME_ENGAGEMENT', label: 'Engagement', optimizationGoalOptions: [0] },
  { id: 5, value: 'OUTCOME_AWARENESS', label: 'Awareness', optimizationGoalOptions: [0] },
  { id: 6, value: 'OUTCOME_APP_PROMOTION', label: 'App Promotion', optimizationGoalOptions: [0] },
];

export const callToActionButtonOptions = [
  { label: 'No button', value: '' },
  { label: 'Shop now', value: 'SHOP_NOW' },
  { label: 'Order now', value: 'ORDER_NOW' },
  { label: 'Learn more', value: 'LEARN_MORE' },
  { label: 'Subscribe', value: 'SUBSCRIBE' },
  { label: 'Sign up', value: 'SIGN_UP' },
  { label: 'Download', value: 'DOWNLOAD' },
  { label: 'Get showtimes', value: 'GET_SHOWTIMES' },
  { label: 'Listen now', value: 'LISTEN_NOW' },
];

export const appCallToActionButtonOptions = [
  { label: 'Download', value: 'DOWNLOAD' },
  { label: 'Shop now', value: 'SHOP_NOW' },
  { label: 'Book travel', value: 'BOOK_TRAVEL' },
  { label: 'Install mobile app', value: 'INSTALL_MOBILE_APP' },
  { label: 'Use mobile app', value: 'USE_MOBILE_APP' },
  { label: 'Watch more', value: 'WATCH_MORE' },
  { label: 'Open Link', value: 'OPEN_LINK' },
  { label: 'Learn more', value: 'LEARN_MORE' },
  { label: 'Subscribe', value: 'SUBSCRIBE' },
  { label: 'Sign up', value: 'SIGN_UP' },
  { label: 'Listen now', value: 'LISTEN_NOW' },
];

export const appStoresOptions = [
  { label: 'Apple App Store', value: 'IOS' },
  { label: 'Google Play Store', value: 'Android' },
];

export const platformOptions = [
  { id: 1, label: 'Mobile', value: 'mobile' },
  { id: 2, label: 'Desktop', value: 'desktop' },
];

export const publisherOptions = [
  { label: 'Facebook', value: 'facebook', platforms: [1, 2], objectives: [1, 2, 3, 4, 5, 6] },
  { label: 'Instagram', value: 'instagram', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
  { label: 'Messenger', value: 'messenger', platforms: [1], objectives: [1, 2, 3, 5, 6] },
  { label: 'Audience network', value: 'audience_network', platforms: [1], objectives: [1, 2, 3, 5, 6] },
];

export const positionsOptions = {
  facebook: [
    { label: 'Feed', value: 'feed', platforms: [1, 2], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Right hand column', value: 'right_hand_column', platforms: [2], objectives: [1, 2, 3, 4] },
    { label: 'Marketplace', value: 'marketplace', platforms: [1, 2], objectives: [1, 2, 3, 4, 5] },
    { label: 'Video feeds', value: 'video_feeds', platforms: [1, 2], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Story', value: 'story', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Search', value: 'search', platforms: [1, 2], objectives: [1, 2, 3, 4, 5] },
    { label: 'Instream video', value: 'instream_video', platforms: [1, 2], objectives: [1, 2, 3, 4, 5] },
    { label: 'Facebook reels', value: 'facebook_reels', platforms: [1], objectives: [1, 2, 3, 4, 5] },
  ],
  instagram: [
    { label: 'Instagram Search', value: 'ig_search', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Stream', value: 'stream', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Story', value: 'story', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Explore', value: 'explore', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Explore Home', value: 'explore_home', platforms: [1], objectives: [1, 2, 4, 5, 6] },
    { label: 'Reels', value: 'reels', platforms: [1], objectives: [1, 2, 3, 4, 6] },
    { label: 'Profile Feed', value: 'profile_feed', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
  ],
  messenger: [
    { label: 'Messenger Home', value: 'messenger_home', platforms: [1], objectives: [1, 2, 3, 4] },
    { label: 'Sponsored Messages', value: 'sponsored_messages', platforms: [1], objectives: [] },
    { label: 'Story', value: 'story', platforms: [1], objectives: [2, 3, 4, 5, 6] },
  ],

  audience_network: [
    { label: 'Classic', value: 'classic', platforms: [1], objectives: [1, 2, 3, 4, 5, 6] },
    { label: 'Rewarded video', value: 'rewarded_video', platforms: [1], objectives: [1, 2, 3, 4, 6] },
  ],
};

export const attributionSpecOptions = [
  { label: '7-day click or 1-day view', value: '7dayClick1dayView' },
  { label: '7-day click', value: '7dayClick' },
  { label: '1-day click or 1-day view', value: '1dayClick1dayView' },
  { label: '1-day click', value: '1dayClick' },
];

// a list of the EU countries that require payer and beneficiary information
export const regulatoryCountriesEU = [
  'Åland Islands',
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'French Guiana',
  'Germany',
  'Greece',
  'Guadeloupe',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Martinique',
  'Mayotte',
  'Netherlands',
  'Poland',
  'Portugal',
  'Réunion',
  'Romania',
  'Saint Martin, (French part)',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
];
